import React, { memo } from "react";
import PropTypes from "prop-types";
import { Box, Button, ButtonGroup, Tooltip } from "@material-ui/core";
import { LocalAtm, CreditCard, AccountBalance } from "@material-ui/icons";

const PaymentModeButtons = ({ value = 1, onChange = () => { }, disabled = false, className }) => {
  const v = Number.isFinite(Number(value)) ? Number(value) : 1;

  return (
    <Box sx={{ display: "flex", gap: '4px' }} size="small" aria-label="Selector de forma de pago">
      <Tooltip title="Efectivo">
        <Button
          title="Efectivo"
          onClick={() => onChange(0)}
          variant={v === 0 ? "contained" : "outlined"}
          color={v === 0 ? "primary" : "default"}
          aria-pressed={v === 0}
          aria-label="Efectivo"
          style={{ minWidth: 44, height: 40 }}
          disabled={disabled}
        >
          <LocalAtm />
        </Button>
      </Tooltip>

      <Tooltip title="Tarjeta">
        <Button
          title="Tarjeta"
          onClick={() => onChange(1)}
          variant={v === 1 ? "contained" : "outlined"}
          color={v === 1 ? "primary" : "default"}
          aria-pressed={v === 1}
          aria-label="Tarjeta"
          style={{ minWidth: 44, height: 40 }}
          disabled={disabled}
        >
          <CreditCard />
        </Button>
      </Tooltip>

      <Tooltip title="Transferencia">
        <Button
          title="Transferencia"
          onClick={() => onChange(2)}
          variant={v === 2 ? "contained" : "outlined"}
          color={v === 2 ? "primary" : "default"}
          aria-pressed={v === 2}
          aria-label="Transferencia"
          style={{ minWidth: 44, height: 40 }}
          disabled={disabled}
        >
          <AccountBalance />
        </Button>
      </Tooltip>
    </Box>
  );
};

PaymentModeButtons.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

PaymentModeButtons.defaultProps = {
  value: 1,
  onChange: () => { },
  disabled: false,
  className: undefined,
};

export default memo(PaymentModeButtons);